import { SVGProps } from 'react';

const CheckIcon = (props: SVGProps<SVGSVGElement> & { iconColor?: string }) => {
  const { iconColor, ...rest } = props;
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.6651 6.35159C19.8795 6.57662 20 6.88179 20 7.19999C20 7.51818 19.8795 7.82335 19.6651 8.04839L10.5141 17.6484C10.2995 17.8734 10.0087 17.9997 9.70534 17.9997C9.40202 17.9997 9.11112 17.8734 8.89662 17.6484L4.3211 12.8484C4.11273 12.6221 3.99744 12.3189 4.00004 12.0043C4.00265 11.6897 4.12295 11.3887 4.33503 11.1662C4.54712 10.9437 4.83402 10.8175 5.13394 10.8148C5.43386 10.812 5.72281 10.933 5.93854 11.1516L9.70534 15.1032L18.0476 6.35159C18.2622 6.12662 18.5531 6.00024 18.8564 6.00024C19.1597 6.00024 19.4506 6.12662 19.6651 6.35159Z'
        fill={iconColor || '#1E7461'}
      />
    </svg>
  );
};

export default CheckIcon;
